import { createSlice } from '@reduxjs/toolkit';
import { buildAsyncReducers } from '../thunkTemplate';
import { sites as initialState } from '../initialState';

import { getSites, putSite } from './_sites';

const { reducer, actions } = createSlice({
  name: 'sites',
  initialState,
  reducers: {
    setSites: (state, { payload }) => ({
      ...state,
      data: payload,
    }),
  },
  extraReducers: (builder) => {
    buildAsyncReducers(builder, [getSites, putSite]);
  },
});

const { setSites } = actions;

export { getSites, putSite, setSites };
export default reducer;
